import { gql } from "@apollo/client";

export const CreateConsumerScan = gql`
mutation CaptureConsumerScan($consumerScanInput: ConsumerScanInput!) {
  captureConsumerScan(consumerScanInput: $consumerScanInput)
}
`
export const CaptureConsumerEngagementFeedbacks = gql`
mutation CaptureConsumerEngagementFeedbacks($consumerEngagementFeedbackInput: ConsumerEngagementFeedbackInput!) {
  captureConsumerEngagementFeedbacks(consumerEngagementFeedbackInput: $consumerEngagementFeedbackInput) {
  message  
  }
}
`

export const RequestOtpForFeedback= gql`mutation RequestOtpForFeedback($otpRequest: OtpRequestInput!) {
  requestOtpForFeedback(otpRequest: $otpRequest) {
    message
    id
    exists
  }
}`